const en = {
  // Errors
  errors: {
    unauthorized: 'Unauthorized',
    unauthorizedMessage: 'Not authorized. Please login.',
    ups: 'Error',
    pageNotFound: 'Page not found.',
    forbidden: 'Oops! Error 403, Access to this section of webpage is forbidden.',
    mismatch: 'Your passwords do not match',
    missingInput: 'Please correctly insert the missing data: '
  },
  alerts: {
    success: 'Success!',
    error: 'Error!',
    results: 'Exam answers are not yet available, because exam has not been solved yet!'
  },
  header: {
    reports: 'Reports',
    users: 'Users',
    tablets: 'Tablets',
    groups: 'Groups',
    langEng: 'English', // language is not translated
    langSlo: 'Slovenščina', // language is not translated
    exercises: 'Exercises',
    progress: 'Rating',
    leave: 'Groups',
    classes: 'Classes',
    exams: 'Exams',
    statistics: 'Statistics',
    panel: 'Control Panel',
    library: 'Library',
    reportsStart: 'You have',
    reportsEnd: 'pending reports',
    reportsView: 'View all reports',
    version: 'Version',
    literature: 'Literature'
  },
  pages: {
    confirmEmail: {
      success: 'Your email was successfully confirmed!',
      fail: 'Your token has expired'
    },
    literature: {
      literature: 'Literature',
      bannerName: 'Literature',
      addButton: 'Add a button',
      studyLiterature: 'Study literature',
      videos: 'Lecture videos',
      buttonAdded: 'The button has been added!',
      insertButtonText: 'Insert button text: ',
      insertButtonLink: 'Insert button link : ',
      storeButton: 'Store a button',
      storeKeyword: 'Store a keyword',
      keywordStored: 'The keyword has been added!',
      insertKeyword: 'Insert keyword: ',
      storeVideoButton: 'Store a new video button',
      storeTextButton: 'Store a new text button'
    },
    group: {
      bannerName: 'Groups',
      bannerName2: 'Your groups',
      welcomeMessage: 'Other Groups',
      welcomeMessage2: 'Your groups',
      welcomeMessage3: 'Archived groups',
      joinMsg: 'Join group',
      searchMsg: 'Search topic',
      enter: 'Enter',
      leaveGroup: 'Leave group',
      opensAt: 'Opens at',
      duration: 'Duration',
      owner: 'Owner',
      enrolled: 'Enrolled',
      pending: 'Unconfirmed',
      archived: 'Archived',
      await: 'Awaiting confirmation',
      awaitModalOne: 'Your enrollment has not yet been confirmed for this year of this group.',
      awaitModalTwo: 'Please wait for your confirmation.',
      joinGroup: 'Join group'
    },
    subgroups: {
      dailyExercises: 'Daily exercises',
      noDaily: 'Create a new daily challenge',
      createSubGroup: 'Create subgroup',
      addExercises: 'Add exercises',
      emptyExercises: 'This group is empty.',
      exam: 'Exam',
      coverage: 'Subgroups coverage',
      emptySubgroup: 'This subgroup is empty!',
      noQuizzes: 'There are no quizzes in this subgroup.',
      resetExercises: 'Coming soon: Reset exercises',
      editSubgroup: 'Edit subgroup',
      reorderSubgroup: 'Reorder exercises',
      editExercises: 'Edit exercises',
      previewExercises: 'Preview exercises',
      literature: 'Literature',
      examsAndQuizzes: 'Quizzes',
      examsAndQuizzesDescriptionCollapsed: 'Show all quizzes',
      examsAndQuizzesDescriptionNotCollapsed: 'Hide all quizzes',
      reorder: 'Reorder subgroups',
      selectSubgroups: 'Select subgroups',
      startQuiz: 'Start quiz',
      createQuiz: 'Create quiz',
      generatedQuiz: 'Rating quiz',
      addAll: 'Add all',
      removeAll: 'Remove all',
      selectDuration: 'Select duration',
      createQuizForOtherUsers: 'Create quiz for other users',
      editRules: {
        addRule: 'Add rule',
        deleteRuleModal: 'Delete rule',
        confirmDeleteMessage: 'Are you sure you want to delete this rule?',
        deleteConfirm: 'Delete',
        deleteCancel: 'Cancel',
        editRule: 'Edit rule',
        editRules: 'Edit rules',
        thereAreNoRules: 'This subgroup does not contain any rules.',
        identifier: 'Identifier',
        title: 'Title',
        author: 'Author',
        source: 'Source',
        tags: 'Tags',
        tagFilter: 'Tag filter',
        excludedTags: 'Excluded tags',
        languages: 'Languages',
        type: 'Type',
        isOwner: 'Owner',
        isPublic: 'Public',
        isTrue: 'True',
        isFalse: 'False'
      },
      importStructure: 'Import structure',
      uploadSentence: 'Drag and drop YAML file',
      uploadSentence2: 'or click here',
      uploading: 'Uploading...',
      successMsg: 'Group structure imported successfully',
      errorMsg: 'Error has occurred while importing your group structure!',
      exportGroup: 'Export group',
      recomputeGroup: '(Re)compute group',
      pleaseWait: 'Please wait',
      subgroup: 'Subgroup',
      numberOfExercises: 'Number of exercises',
      yamlError: 'An error occured during YAML import.',
      recomputeError: 'An error occured during group recompute.',
      yamlSuccess: 'YAML import is completed.',
      recomputeSuccess: 'Group is recomputed.',
      yamlProgress: 'Subgroups are generating.',
      recomputeProgress: 'Group is recomputing.',
      progress: 'Progress',
      showExercises: 'Show exercises in this subgroup'
    },
    exams: {
      finish: 'Submit',
      areYouSure: 'Are you sure you want to finish ?',
      timeLeft: 'Time left',
      minutes: 'minutes',
      seconds: 'seconds',
      timeForThisExercise: 'Time for this exercise',
      timeForExam: 'Time for exam',
      nextExerciseIn: 'Next exercise in',
      continueNextExercise: 'Start the next exercise now',
      oneExerciseAtATimeWarning: 'This quiz requires solving one exercise at a time. After advancing to the next exercise, returning to the previous one is impossible.',
      examinationInfo: 'Examination info',
      allowedAttempts: 'Number of allowed attempts',
      thisAttemptNumber: 'Consecutive attempt number',
      exercisesList: 'Exercise list',
      endOfExam: 'Exam is finished.',
      question: 'Question',
      answered: 'answered',
      notAnswered: 'not answered',
      noLimit: 'Unlimited',
      remaining: 'remaining',
      start: 'Start',
      finishTime: 'Finish',
      begin: 'Begin',
      createExam: 'Create exam',
      name: 'Name',
      examNotScheduled: 'Exam is not scheduled',
      goToEditExam: 'Edit exam',
      published: 'Published',
      seatingPosition: 'Seat number',
      showAttempts: 'Show attempts',
      currentStatistics: {
        ExerciseName: 'Exercise: ',
        nextExercise: 'Next',
        lastExercise: 'Previous',
        answer: 'ANSW: '
      },
      attemptHistory: {
        attempt: 'Attempt',
        startedAt: 'Started',
        finishedAt: 'Finished',
        status: 'Status',
        grade: 'Grade',
        unavailable: 'Unavailable',
        finished: 'Finished',
        inProgress: 'In progress',
        showAttempt: 'Show attempt',
        examName: 'Exam name',
        allExams: 'All exams'
      },
      editExam: {
        refreshExercises: 'Fetch latest exercise versions',
        editExam: 'Edit Exam',
        updated: 'Successfully updated',
        unpublishWarning: 'Unpublish all class exams to edit this exam',
        exam: 'Exam',
        quiz: 'Quiz',
        selectType: 'Select type',
        maxRetries: 'Select number of retries',
        oneAtATime: 'One exercise a a time',
        shuffle: 'Shuffle exercises',
        enabled: 'Enabled',
        disabled: 'Disabled',
        noLimit: 'Unlimited',
        exercises: 'Exercises',
        tableData: 'Data ID',
        tableTags: 'Tags',
        tablePos: 'Positive points',
        tableNeg: 'Negative points',
        tableAllow: 'Allow negative',
        classExams: 'Class exams',
        tableClass: 'Class',
        tablePass: 'Password',
        tableDateTime: 'Date and time',
        tableDuration: 'Duration',
        classRoom: 'Classroom',
        addClassroom: 'Add classroom',
        manageClassrooms: 'Manage classrooms',
        wingsNumber: 'Number of wings: ',
        apply: 'Apply',
        insertRowsForEachWing: 'Insert numbers of rows for each wing',
        wing: 'Wing',
        row: 'Row',
        setSeats: 'Select number of seats for every row',
        validClassroom: 'Classroom succesfully created. Please enter its name: ',
        selectSeat: 'Select your seat in the classroom',
        passwordNotSet: 'Not set',
        timeMinutes: 'minutes',
        timeHours: 'hours',
        timeDays: 'days',
        publish: 'Publish',
        unpublish: 'Unpublish',
        save: 'Save and Exit',
        tablePoints: 'Points',
        tableTime: 'Exercise time [s]',
        question: 'Question',
        allowed: 'Negative',
        notAllowed: 'No negative',
        displayResults: 'Display results',
        showResults: 'Show results',
        hideResults: 'Hide results',
        copyExercises: 'Copy exercises',
        ratingExercises: 'Rating exercises',
        fromGroup: 'From group',
        addExercises: 'Add exercises',
        versions: 'versions',
        exerciseVersions: 'All exercise versions',
        collapseParametric: 'Collapse parametric',
        expandParametric: 'Expand parametric',
        modals: {
          changePassword: 'Change password',
          noPassword: 'If this class exam doesn\'t need a password, leave the input area empty',
          update: 'Update',
          searchExercises: 'Search exercises',
          cancel: 'Cancel',
          add: 'Add exercises',
          deleteTitle: 'Are you sure you want to delete this exam?',
          deleteConfirm: 'Delete',
          deleteCancel: 'Cancel',
          updateTitle: 'Are you shore?',
          updateBody: 'Updating exercise versions will delete all student-submitted answers?',
          confirmFetchLatest: 'Confirm exercise update'
        }
      },
      classrooms: {
        addClassroom: 'Add a classroom',
        classroomID: 'ID',
        classroomName: 'Classroom name',
        showSketch: 'Show sketch',
        delete: 'Delete',
        successfullySeated: 'The selected seat is valid. Press the button if you are ready to procceed.',
        showExecGroups: 'Show exercise groups',
        hideExecGroups: 'Hide exercise groups',
        showSeatMarks: 'Show seat marks',
        manageClassrooms: 'Classrooms',
        allClassroomsList: 'All Classrooms Available',
        colorGroup: 'Select a group to color',
        customizeGroups: 'Customize colors',
        selectColorSeats: 'Select seats to color',
        customizeColoring: 'Customize coloring',
        turnOffCustomizeColoring: 'Turn off custom coloring',
        selectColors: 'Select color',
        selectedSeats: 'Selected seats',
        turnOnGroupEditor: 'Turn on group editor',
        groupEditorTurnedOn: 'GROUP EDITOR IS TURNED ON',
        turnOffGroupEditor: 'Turn off group editor',
        selectGroup: 'Select a group to assign'
      },
      ratingResults: {
        ratingExamResults: 'Rating exam results',
        achievvedPoints: 'Achieved points',
        possiblePoints: 'Available points',
        percent: 'Percent',
        rating: 'Rating',
        ratingChange: 'Change of rating',
        ratingAccuracy: 'Accuracy of rating',
        highAccuracy: 'High accuracz',
        mediumHighAccuracy: 'Medium accuracy',
        mediumLowAccuracy: 'Medium accuracy',
        lowAccuracy: 'Low accuracy',
        viewYourAnswers: 'View your answers',
        ratingHistory: 'Rating history',
        completeMoreQuizes: 'Complete more quizes to join the leaderboard',
        yourRatingIsInaccurate: 'Your rating accuracy needs to reach at least',
        leaderboard: 'Leaderboard',
        joinedLeaderboard: 'You have successfully joined the Leaderboard!',
        improveRating: 'Complete more quizes to score higher',
        numberOfSolvedExercises: 'Solved exercises',
        leaderboardEmpty: 'No one made it to the leaderboard yet',
        infoTitle: 'User and exercise ratings',
        info: 'When completing a Rating exam, user and exercises on the quiz are rated according to your results.',
        infoDeviation: 'Rating system in eQuiz takes into account the accuracy of your rating. At first, your rating is not accurate, due to small amounts of data your rating is based on. More quizes you complete, ' +
                       'more accurate your rating becomes. To join the Leaderboard, your rating needs to be at least 75% accurate. ' +
                       'Your accuracy also slowly decreases if you are inactive',
        ratingQuizInfo: 'In Rating exam, you will get a collection of randomly chosen exercises from your chosen exercise subgroup. ' +
                        'Based on your results we will calculate your new rating and the rating of exercises on your exam. You can see the solutions and ratings of your' +
                        ' exercises in the View your answers section after the exam.'
      }
    },
    home: {
      helloRegister: 'Don\'t have an account yet?'
    },
    login: {
      username: 'Username',
      password: 'Password',
      remeberMe: 'Remember me',
      login: 'Sign in',
      loginSMsg: 'Login successful!',
      forgotPassword: 'Forgot password?',
      google: 'Sign in with Google'
    },
    register: {
      email: 'Email',
      username: 'Username',
      name: 'Name',
      surname: 'Surname',
      studentId: 'StudentId',
      password: 'Password',
      passwordRetype: 'Retype password',
      register: 'Register',
      registerSMsg: 'Registration successful',
      addNew: 'Add new user',
      addButton: 'Add',
      newUserRole: 'Role',
      mismatch: 'Your passwords do not match',
      recap: 'Prove you are not a robot!',
      ssoMissingData: 'Insert missing data',
      ssoMissingDataSubmit: 'Submit',
      ssoMissingDataLogOut: 'Logout',
      ssoMissingDataEmpty: 'Field is empty',
      ssoMissingDataStudentIdInvalid: 'Student ID is incorrect',
      alreadyHaveAnAccount: 'Already have an account?',
      emailSent: 'Confirm you email account',
      emailSentSuccess: 'Registration successful! Please check your email to confirm your registration! Don\'t forget to also check the "spam" folder!'
    },
    resetPassword: {
      title: 'Forgoten password',
      email: 'Email',
      resetMsg: 'Reset Password',
      successMsg: 'Confirmation email sent.',
      back: 'Back to login',
      description: 'Enter the email address to which we will send you instructions for password reset.'
    },
    setPassword: {
      msg: 'Before you start using E-quiz you must first set the password',
      password: 'Password',
      retypePassword: 'Retype password',
      confirmButtonMsg: 'Set',
      successMsg: 'Password set successfully'
    },
    setNewPassword: {
      msg: 'Set your new password',
      password: 'New password',
      retypePassword: 'Retype password',
      confirmButtonMsg: 'Set'
    },
    exercise: {
      examClearExercise: 'Clear',
      finish: 'Finish',
      evaluateExam: 'Submit',
      evaluated: 'Successfully submitted',
      evaluateEssay: 'Submit',
      evaluateText: 'Check',
      hintText: 'Hint',
      solvedText: 'Solution',
      correctMsg: 'Success!',
      wrongMsg: 'Wrong!',
      previous: 'Previous',
      next: 'Next',
      report: 'Report',
      name: 'Exercise',
      info: 'Exercise info',
      point1: 'point',
      point2: 'points',
      point3: 'points',
      point5: 'points',
      points: 'Points',
      pointsNotAvailable: 'Points are unavailable',
      doNotExist: 'does not exist',
      onDelete: 'Exercise deleted successfully',
      modalInfoId: 'title',
      modalInfoAuthor: 'author',
      modalInfoTags: 'tags',
      modalInfoSource: 'source',
      submitEssay: 'Submitted',
      submitExam: 'Submitted',
      back: 'Back',
      rating: 'Exercise rating',
      answers: {
        correct: 'The answer is correct.',
        incorrect: 'The answer is incorrect.',
        partiallyCorrect: 'The answer is partially correct.',
        correctAnswer: {
          singular: 'The correct answer is',
          dual: 'The correct answers are',
          plural: 'The correct answers are'
        },
        noAnswer: 'This question is not graded automatically',
        noSolution: 'There is no solution for this question',
        parametricSolution: 'This exercise is parametric, below are the text and solution for parent exercise',
        parametricSolution2: 'This exercise is parametric, below is the solution for the parent exercise'
      }
    },
    createGroup: {
      prompt: 'Choose a new group',
      name: 'Name',
      description: 'Description',
      coverUrl: 'CoverUrl',
      createButton: 'Create',
      createGroupSMsg: 'Group successfully created!',
      public: 'Public',
      visibility: 'Visible',
      dynamic: 'Dynamic'
    },
    userIconInHeader: {
      pleaseLogin: 'Please log in',
      profile: 'Profile',
      signOut: 'Sign out',
      notLoggedInUsername: 'Guest',
      changeLanguange: 'Change language'
    },
    profile: {
      prompt: 'User profile',
      name: 'Name',
      surname: 'Surname',
      studentId: 'StudentId',
      email: 'Email',
      username: 'Username',
      edit: 'Edit profile',
      save: 'Save',
      generalInfo: 'General',
      phName: 'Insert name',
      phSurname: 'Insert Surname',
      phEmail: 'Insert email',
      phStudentId: 'Insert studentId',
      langSlo: 'Slovenščina', // language is not translated
      langEng: 'English', // language is not translated
      lang: 'Language',
      adminAdmit: 'I grant admin access to my results',
      cancel: 'Cancel',
      update: 'Update',
      student: 'Student',
      userData: 'Personal info',
      avgGrade: 'Average grade',
      grade: 'Grade',
      userpicture: {
        userPicture: 'User picture',
        loadPicture: 'Drag and drop picture',
        loadPicture2: 'or click here',
        load: 'Load picture',
        uploading: 'Uploading picture ...',
        success: 'Profile picture updated successfully',
        errorMsg: 'Error has occurred while uploading profile picture, check file type!',
        change: 'Update image',
        delete: 'Delete image'
      },
      changepassword: {
        userPassword: 'Change password',
        oldPass: 'Old password',
        newPass: 'New password',
        change: 'Change password',
        repeatNewPass: 'Repeat password',
        phOldPass: 'Insert old password',
        phNewPass: 'Insert new password',
        noMatch: 'Passwords don\'t match',
        success: 'Password update was successful'
      },
      changeroles: {
        changeRole: 'Change Role',
        changeRoleButton: 'Change'
      }
    },
    language: {
      locale: 'locale'
    },
    reports: {
      reported: 'Reported',
      comment: 'Comment',
      status: 'Status',
      edit: 'Edit',
      comparePending: 'pending',
      compareIgnored: 'ignored',
      compareResolved: 'resolved',
      exerciseReports: 'Exercise reports',
      user: 'Uporabnik',
      report: 'Report exercise',
      close: 'Close',
      save: 'Save',
      reportSuccessful: 'Report successful',
      reportsOnExec: 'All reports on exercise ',
      reportUserId: 'User ID',
      reportDescription: 'Report description',
      reportStatus: 'Report status',
      reportReact: 'React',
      noReportsFound: 'There are no reports registered for this exercise'
    },
    exerciseList: {
      exercises: 'Exercise management',
      list: 'List of exercises',
      tableId: 'Id',
      tableDataId: 'Data id',
      tableTags: 'Tags',
      tableAuthor: 'Author',
      tableSource: 'Source',
      tableCreatedAt: 'Created at',
      tableUpdatedAt: 'Updated at',
      tableTitle: 'Title',
      success: 'Successfully added',
      nmPerPage: 'Exercises displayed',
      showAll: 'Show All',
      selectGr: 'Select group',
      selectSgr: 'Select subgroup',
      footSentence: {
        senOne: 'Showing',
        senTwo: 'out of',
        senThree: 'exercises'
      },
      page: 'Page',
      library: 'Library',
      import: 'Import exercises',
      addNew: 'Add a new exercise',
      importRating: 'Import/Export rating',
      importTitle: 'Import',
      exportTitle: 'Export',
      downloadCSV: 'Download csv',
      uploadRatingSuccess: 'Successfully uploaded rating data.',
      uploadRatingError: 'An error occured while uploading document.',
      dragToUpload: 'Drag your CSV file here.',
      uploading: 'Uploading.',
      upload: 'Upload',
      uploadPictures: 'Upload Pictures',
      uploadSuccess: 'Pictures uploaded successfully',
      uploadErrorMsg: 'Error has occurred while uploading pictures, check file type!',
      hide: 'Hide',
      startWith: 'Starts with',
      contains: 'Contains',
      showAdvanced: 'Show advanced search options',
      hideAdvanced: 'Hide advanced search options',
      owner: 'Owner',
      public: 'Public',
      search: 'Search',
      reset: 'Reset filters',
      importButton: 'Import .tex',
      addExerciseButton: 'Add new exercise',
      addTags: 'Add tags seperated by a comma',
      showHideSub: 'Show / Hide Subexercises',
      addSubExec: 'Add sub-exercise',
      showBasicInfo: 'Show basic info',
      hideBasicInfo: 'Hide basic info',
      currentSubExecCnt: 'Current number of sub-exercises: ',
      execPreText: 'Add exercise pre-text / description: ',
      chooseNewExecInputMethod: 'Choose the preffered input method for the new exercise',
      inputMethodLatex: 'via LaTeX',
      inputMethodInterface: 'via Interface',
      inputMethodBober: 'Bober',
      latexSave: 'Save and import',
      execInputAnswer: 'Input answer',
      execInputPrecision: 'Input answer precision',
      execAddHint: 'Optionally add a hint: ',
      finishExec: 'Finish and add to library',
      finishSubExec: 'Finish and add subexercise',
      latexSuccessfullyImported: 'Successfully imported',
      radioAddAnswer: 'Add another answer',
      radioAddAnswerIfCorrect: 'Correct? ',
      cancel: 'Cancel',
      radioMultipleCorrect: 'Only one answer can be correct',
      answersSoFar: 'All answers so far',
      inputBasicExecInfo: 'Insert basic exercise info',
      addToSubgroup: 'Add to a subgroup',
      add: 'Add',
      chooseExecType: 'Choose execrise (answer) type',
      typeNumerical: 'Numerical (number)',
      typeRadio: 'Radio (true / false)',
      typeEssay: 'Essay (sentence)',
      typeMultichoice: 'Multichoice (select)',
      typeLikert: 'Likert (scale)',
      execTypeQuestion: 'Input question: ',
      updated: 'Successfully updated',
      deleted: 'Successfully deleted',
      statement: 'Statement',
      of: 'of',
      next: 'Next',
      previous: 'Previous',
      placeholders: {
        dataId: 'Search exercises library',
        title: 'Search by title',
        author: 'Search by author',
        source: 'Search by source',
        tags: 'Tags',
        tagsExclude: 'Exclude tags',
        languages: 'Languages',
        types: 'Types'
      }
    },
    preview: 'Preview exercise',
    editexercise: {
      prompt: 'Edit exercise',
      uploadNew: 'Upload new exercise instead',
      title: 'Exercise title',
      description: 'Exercise description'
    },
    ratingHistory: {
      currentRating: 'Current rating',
      bestRating: 'Best rating',
      worstRating: 'Worst rating',
      ratingHistory: 'History of rating exams',
      numberOfPoints: 'Points',
      date: 'Date',
      rating: 'Rating',
      startQuiz: 'Start rating exam',
      ratingQuiz: 'Rating exam',
      graph: 'Graph'
    },
    buttons: {
      add: 'Add',
      create: 'Create',
      save: 'Save',
      edit: 'Edit',
      delete: 'Delete',
      update: 'Update',
      success: 'Success',
      fail: 'Error',
      updated: 'Updated',
      confirm: 'Confirm',
      deleteP: 'Are you sure you want proceed? You will lose all containing subgroups, progress tags and exams.',
      search: 'Search',
      showAll: 'Show all',
      cancel: 'Cancel',
      goToUserProfile: 'Go to user profile',
      details: 'Details',
      back: 'Back',
      refresh: 'Refresh'
    },
    requiredField: {
      enterPrompt: 'Required fields',
      firstName: 'First name',
      lastName: 'Last name',
      studentId: 'Student id',
      allowUseOfMyResults: 'Allow use of my results',
      username: 'Username',
      email: 'Email',
      emailVerifiedAt: 'Email verified at',
      password: 'Password',
      profilePictureUrl: 'Profile picture'
    },
    adminpanel: {
      statistics: {
        group: 'Statistics',
        show: 'Show',
        registered: 'Number of registered users',
        active: 'Number of active users',
        exC: 'Correct',
        ecW: 'Wrong'
      },
      ratingStatistics: {
        bannerName: 'Rating',
        group: 'Statistics for rating in this group',
        userRatings: 'Histogram of student rating values',
        numberOfStudents: 'Number of students',
        exerciseRatings: 'Histogram of exercise ratings',
        numberOfExercises: 'Number of exercises',
        ratingExamsInLastWeek: 'Rating exams in the last week',
        averageRatingChange: 'Average change of student ratings in last week',
        exportUserRatingsCSV: 'Download CSV with user ratings',
        downloadAllUsers: 'Dowload rating of all users',
        name: 'Name',
        downloadSingleClass: 'Download single class:',
        userRatingStatistics: 'Rating statistics of individual users',
        studentId: 'Student id',
        numberOfRatingTests: 'Number of rating tests',
        currentRating: 'Current rating',
        showMore: 'Show more',
        hiddenStatistics: 'The results are hidden',
        studentRatings: 'Student ratings'
      },
      createdailychallenge: {
        editName: 'Name',
        isActive: 'Active',
        create: 'Create',
        save: 'save',
        dateRange: 'From/To',
        result: 'Show result',
        exercise: 'Exercise title',
        findExercise: 'Start typing to search exercises',
        successDelete: 'Daily challenge deleted successfully'
      },
      users: {
        listOfUsers: 'List of users',
        search: 'Search',
        tableId: 'Id',
        tableUser: 'User',
        tableDate: 'Date',
        tableRole: 'Roles',
        bannerName: 'Users',
        manageUsersButton: 'Manage Users',
        nmOfUsersPrompt: 'Enrolled Users',
        userActivity: 'User activity',
        createGroup: 'Add new group'
      },
      classes: {
        bannerName: 'Classes',
        manageClassesButton: 'Manage classes',
        awaiting: 'Awaiting confirmation',
        tableId: 'Id',
        tableUser: 'User',
        tableDate: 'Date',
        tableStudentId: 'Student id',
        confirm: 'Confirm',
        move: 'Move',
        createClass: 'Create a new class',
        deleteClass: 'Delete class',
        confirmation: 'Are you sure you want to delete this class?',
        toDefault: 'All class enrollments will be placed into default class.',
        cancel: 'Cancel',
        deleteEnrollment: 'Delete enrollment',
        confirmation2: 'Are you sure you want to disenroll this student?',
        autoEnrollDisable: 'Disable auto-enrollment',
        autoEnrollEnable: 'Select class for auto-enrollment',
        defaultClass: 'Auto-enrollment class',
        exportUserRatingForClass: 'Rating of this class',
        exportUserRatingForGroup: 'Rating of entire group'
      },
      group: {
        createPrompt: 'Create group',
        groupPrompt: 'Group',
        createGroupPrompt: 'Please create new group',
        public: 'Public',
        editGroup: 'Edit group',
        editYear: 'Edit year',
        createYear: 'Create new year',
        archiveGroup: 'Archive year',
        editId: 'Id',
        editName: 'Name',
        editDescription: 'Description',
        editCover: 'CoverUrl',
        save: 'Save',
        color: 'Color'
      },
      subgroup: {
        nmOfSubgroupsPrompt: 'Subgroups',
        editSubgroup: 'EditSubgroup',
        editName: 'Name',
        editDescription: 'Description',
        visibility: 'Visible',
        save: 'save',
        editVideoLink: 'Youtube',
        editVideoTime: 'Video start (mm:ss)'
      },
      exercises: {
        bannerName: 'Exercises',
        manageExercisesButton: 'Manage Exercise Groups',
        loadExercise: 'Drag and drop exercise',
        loadExercise2: 'or click here',
        successMsg: 'Exercises imported successfully',
        errorMsg: 'An error has occurred',
        uploading: 'Uploading exercises ...'
      },
      tablets: {
        bannerName: 'Tablets',
        manageExamsButton: 'Manage tablets',
        nmOfExamsPrompt: 'Quizzes and Exams',
        listOfAnnouncedDevices: 'List of announced devices',
        identifier: 'Id',
        deviceName: 'Device name',
        created: 'Created',
        updated: 'Last active',
        search: 'Search',
        register: 'Register device',
        name: 'Name',
        group: 'Group',
        comment: 'Comment',
        password: 'Password',
        modalApproveYes: 'Approve',
        modalApproveNo: 'Cancel',
        edit: 'Edit device',
        modalApproveYesEdit: 'Save',
        modalApproveNoEdit: 'Cancel',
        alertSuccess: 'Saved',
        registered: 'Registered',
        listOfAllDevices: 'List of devices',
        delete: 'Delete device',
        modalDeleteYes: 'Confirm',
        generateOtp: 'Generate one-time password'
      },
      year: {
        yearPrompt: 'Year',
        editId: 'Id',
        editName: 'Name',
        editRequiredFields: 'Required fields',
        name: 'Year',
        visibility: 'Visible',
        archived: 'Archived',
        save: 'Save',
        createYear: 'Please create year'
      }
    },
    gradebook: {
      title: 'Gradebook',
      search: 'Search',
      name: 'Name'
    }
  }
}

export default en



// WEBPACK FOOTER //
// ./src/lang/en.js